import React, { Fragment, useRef, useState, useEffect, useContext } from 'react';
import { AuthContext } from '../contexts/auth';
import { Dialog, Transition } from '@headlessui/react';
import { DocumentPlusIcon, CheckIcon, ClockIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
import { getJustificationsCompanyList } from '../services/api_justifications';
import { listOrganizationalUnits } from "../services/api_org_unit";
import ComboboxAutocomplete from './combobox_autocomplete';
import { createEmployeeJustificationRequest } from '../services/api_justification_requests';
import Swal from 'sweetalert2';
import moment from 'moment';
import { estraiMessaggiErrore } from '../services/utils';



const AddGiustificativoModal = ({ closeModalAddGiustificativi, dipendente, formattedDay, selectedJustification, onSaveJustificationRequest, selectedUnit }) => {
    const cancelButtonRef = useRef(null);
    const { token } = useContext(AuthContext);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [error, setError] = useState('');
    const [giustificativi, setGiustificativi] = useState([]);
    const [giustificativoSelected, setGiustificativoSelected] = useState(null);
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [startDay, setStartDay] = useState(formattedDay || '');
    const [endDay, setEndDay] = useState(formattedDay || '');
    const [note, setNote] = useState('');
    const [timeError, setTimeError] = useState('');
    const [isInputReset, setIsInputReset] = useState(false);
    const [units, setUnits] = useState([]);
    const [tempSelectedUnit, setTempSelectedUnit] = useState(null);

    
    useEffect(() => {
        if (selectedUnit) {
            setTempSelectedUnit(selectedUnit);
        }
    }, [selectedUnit]);


    useEffect(() => {
        setIsLoading(true);
        setIsError(false);

        const fetchData = async () => {
            try {
                const giustificativi = await getJustificationsCompanyList(token);
                setGiustificativi(giustificativi);
            } catch (error) {
                console.error('Error fetching justifications:', error);
                setIsError(true);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [token]);

    useEffect(() => {

    }, [giustificativoSelected]);

    useEffect(() => {
        async function fetchData() {
            try {
                setIsLoading(true);
                const unitsData = await listOrganizationalUnits(token, true);
                setUnits(unitsData.data);
                setIsLoading(false);
            } catch (error) {
                console.error('Error fetching units:', error);
                setError(true);
                setIsLoading(false);
            }
        }
        fetchData();
    }, [token]);

    const handleSelectUnit = (selected) => {
        setTempSelectedUnit(selected);
    };

    const handleWorkTimeBlur = (field) => {
        let formattedTime = field === 'start' ? startTime : endTime;
        formattedTime = formattedTime.replace(/\D/g, '');

        while (formattedTime.length < 4) {
            formattedTime += '0';
        }

        formattedTime = formattedTime.slice(0, 4);
        const hours = formattedTime.slice(0, 2);
        const minutes = formattedTime.slice(2);
        formattedTime = `${hours}:${minutes}`;

        const isValidTime = /^([01]?[0-9]|2[0-4]):[0-5][0-9]$/.test(formattedTime);

        if (!isValidTime) {
            if (field === 'start') {
                setStartTime('');
            } else {
                setEndTime('');
            }
            return;
        }

        if (field === 'start') {
            setStartTime(formattedTime);
        } else {
            setEndTime(formattedTime);
        }
    };

    const handleStartTimeChange = (e) => {
        let inputValue = e.target.value;
        inputValue = inputValue.replace(/\D/g, '');
        inputValue = inputValue.slice(0, 4);
        let formattedTime = inputValue.replace(/(\d{2})(\d{0,2})/, "$1:$2");

        if (inputValue.length <= 2 && e.target.value.length < formattedTime.length) {
            formattedTime = formattedTime.replace(":", "");
        }

        setStartTime(formattedTime);

        if (endTime && formattedTime >= endTime) {
            setTimeError("L'orario di inizio deve essere precedente all'orario di fine.");
        } else {
            setTimeError('');
        }
    };

    const handleEndTimeChange = (e) => {
        let inputValue = e.target.value;
        inputValue = inputValue.replace(/\D/g, '');
        inputValue = inputValue.slice(0, 4);
        let formattedTime = inputValue.replace(/(\d{2})(\d{0,2})/, "$1:$2");

        if (inputValue.length <= 2 && e.target.value.length < formattedTime.length) {
            formattedTime = formattedTime.replace(":", "");
        }

        setEndTime(formattedTime);

        if (startTime && formattedTime <= startTime) {
            setTimeError("L'orario di fine deve essere successivo all'orario di inizio.");
        } else {
            setTimeError('');
        }
    };


    const handleKeyDown = (e) => {
        const { name } = e.target;
    
        if (isInputReset) {
            if (name === 'startDay') {
                setStartDay('');
            } else if (name === 'endDay') {
                setEndDay('');
            }
            setIsInputReset(false);
        }
    };
      
    const handleBlur = () => {
        setIsInputReset(false);
    };

    const handleStartDayChange = (e) => {
        let inputValue = e.target.value;
        inputValue = inputValue.replace(/\D/g, '');
        if (inputValue.length > 2 && inputValue.length <= 4) {
          inputValue = `${inputValue.slice(0, 2)}/${inputValue.slice(2)}`;
        } else if (inputValue.length > 4) {
          inputValue = `${inputValue.slice(0, 2)}/${inputValue.slice(2, 4)}/${inputValue.slice(4)}`;
        }
        setStartDay(inputValue);
        if (endDay && inputValue.length === 10) {
            const [startDayPart, startMonth, startYear] = inputValue.split('/');
            const startDate = new Date(`${startYear}-${startMonth}-${startDayPart}`);
    
            const [endDayPart, endMonth, endYear] = endDay.split('/');
            const endDate = new Date(`${endYear}-${endMonth}-${endDayPart}`);
    
            if (startDate >= endDate) {
                setTimeError("La data di inizio deve essere precedente alla data di fine.");
            } else {
                setTimeError('');
            }
        }
    };
    
    const handleEndDayChange = (e) => {
        let inputValue = e.target.value;
        
        inputValue = inputValue.replace(/\D/g, '');
        
        if (inputValue.length > 2 && inputValue.length <= 4) {
            inputValue = `${inputValue.slice(0, 2)}/${inputValue.slice(2)}`;
        } else if (inputValue.length > 4) {
            inputValue = `${inputValue.slice(0, 2)}/${inputValue.slice(2, 4)}/${inputValue.slice(4)}`;
        }
        
        setEndDay(inputValue);
        
        if (startDay && inputValue.length === 10) {
            const [startDayPart, startMonth, startYear] = startDay.split('/');
            const startDate = new Date(`${startYear}-${startMonth}-${startDayPart}`);
            
            const [endDayPart, endMonth, endYear] = inputValue.split('/');
            const endDate = new Date(`${endYear}-${endMonth}-${endDayPart}`);
            
            if (endDate <= startDate) {
                setTimeError("La data di fine deve essere successiva alla data di inizio.");
            } else {
                setTimeError('');
            }
        }
    };
    
    const convertToISOFormat = (dateString) => {
        const [day, month, year] = dateString.split('/');
        return `${year}-${month}-${day}`;
    };
    
    const handleGiustificativoChange = (giustificativo) => {
        setGiustificativoSelected(giustificativo);
    
        if (!giustificativo?.has_hours) {
            setStartTime('00:00');
            setEndTime('24:00');
        } else {
            setStartTime('');
            setEndTime('');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setTimeError('');

        // Verifica dei campi obbligatori
        if (!giustificativoSelected || !startDay || !endDay || !startTime || !endTime) {
            setTimeError("Compila tutti i campi obbligatori.");
            return;
        }

        // Verifica della validità delle date
        if (
            !moment(startDay, 'YYYY-MM-DD', true).isValid() ||
            !moment(endDay, 'YYYY-MM-DD', true).isValid()
        ) {
            setTimeError("Le date selezionate non sono valide.");
            return;
        }

        // Verifica che la data finale non preceda quella iniziale
        if (endDay < startDay) {
            setTimeError("La data di fine non può precedere quella di inizio.");
            return;
        }

        // Verifica della validità degli orari (24:00 consentito solo come fine)
        const isValidStartTime = /^([01]\d|2[0-3]):[0-5]\d$/.test(startTime);
        const isValidEndTime = /^([01]\d|2[0-3]):[0-5]\d$/.test(endTime) || endTime === '24:00';

        if (!isValidStartTime || !isValidEndTime) {
            setTimeError("Gli orari inseriti non sono validi.");
            return;
        }

        // Costruzione data e ora iniziale
        const datetimeFrom = `${startDay}T${startTime}:00`;

        // Costruzione data e ora finale
        let datetimeTo;

        if (endTime === '24:00') {
            // 24:00 corrisponde alle 00:00 del giorno successivo
            datetimeTo = moment(endDay, 'YYYY-MM-DD')
                .add(1, 'day')
                .format('YYYY-MM-DD') + 'T00:00:00';
        } else {
            datetimeTo = `${endDay}T${endTime}:00`;
        }

        // Verifica dell'intervallo temporale
        if (moment(datetimeTo).isSameOrBefore(moment(datetimeFrom))) {
            setTimeError("La data e l'ora di fine devono essere successive a quelle di inizio.");
            return;
        }

        // Payload per l'API
        const data = {
            datetime_from: datetimeFrom,
            datetime_to: datetimeTo,
            note,
            justification: giustificativoSelected.id,
            ou: tempSelectedUnit?.id ?? null,
        };

        setIsLoading(true);

        Swal.fire({
            title: 'Salvataggio in corso...',
            html: 'Attendere',
            didOpen: () => Swal.showLoading(),
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
        });

        try {
            // Salvataggio del giustificativo
            await createEmployeeJustificationRequest(
                token,
                dipendente.id,
                data
            );

            // Chiude il loader
            Swal.close();

            // Aggiornamento del calendario tramite callback
            // Richiamato solo dopo il salvataggio completato
            try {
                await onSaveJustificationRequest?.(
                    data,
                    dipendente.id,
                    formattedDay
                );
            } catch (refreshError) {
                console.error(
                    "Giustificativo salvato, ma errore durante l'aggiornamento del calendario:",
                    refreshError
                );
            }

            // Chiude la modale
            closeModalAddGiustificativi();

            // Conferma del salvataggio
            await Swal.fire({
                icon: 'success',
                title: 'Salvato!',
                text: 'La richiesta di giustificativo è stata inserita.',
                timer: 1000,
                showConfirmButton: false,
            });

        } catch (error) {
            console.error("Errore durante il salvataggio del giustificativo:", error);

            Swal.close();

            const errorMessage =
                estraiMessaggiErrore(error) ||
                "Si è verificato un errore durante il salvataggio.";

            await Swal.fire({
                icon: 'error',
                title: 'Errore',
                text: errorMessage,
                confirmButtonText: 'OK',
            });

        } finally {
            setIsLoading(false);
        }
    };
    

    return (
        <Transition.Root show={true} as={Fragment}>
            <Dialog as="div" className="fixed inset-0 overflow-y-auto top-10" style={{ zIndex: '999' }} onClose={() => {}} initialFocus={cancelButtonRef}>
                <div className="flex items-start justify-center min-h-screen px-4 text-center sm:block sm:p-0">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
                    </Transition.Child>

                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <div className="inline-block bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-2/3 sm:w-1/3 mt-20 sm:mt-30 top-0">
                            <div className="border-b border-gray-200 text-center flex items-center justify-center bg-indigo-200 py-3">
                                <DocumentPlusIcon className="h-5 w-5 text-indigo-700" /><span className='w-4'></span>
                                <Dialog.Title as="h3" className="text-lg font-semibold text-indigo-700">
                                    Aggiungi Giustificativo
                                </Dialog.Title>
                            </div>
                            <form onSubmit={handleSubmit} className='p-4'>
                                <div className='grid grid-cols-2 gap-3 w-full p-2 align-middle'>
                                    <div className='col-span-1 font-semibold text-sm text-gray-600 uppercase pt-1'>
                                        Dipendente
                                    </div>
                                    <div className='col-span-1 text-sm text-gray-600 flex-col items-center'>
                                        {dipendente.last_name && dipendente.first_name ? `${dipendente.last_name} ${dipendente.first_name}` : dipendente.cf}
                                    </div>
                                    <div className='col-span-1 font-semibold text-sm text-gray-600 uppercase pt-1'>
                                        Fasce orarie lavoro
                                    </div>
                                    <div className='col-span-1 text-sm flex-col items-center'>
                                        {selectedJustification && selectedJustification.time_slots && selectedJustification.time_slots.length > 0 ? (
                                            selectedJustification.time_slots
                                                .slice()
                                                .sort((a, b) => a.start_at.localeCompare(b.start_at)) // Ordina per orario di inizio
                                                .map((timeSlot, index) => (
                                                    <div key={index} className="mb-2 flex items-center">
                                                        <div>
                                                            <div className='flex items-center text-xs'>
                                                                {timeSlot.start_at} - {timeSlot.end_at}
                                                            </div>
                                                            {timeSlot.breaks && timeSlot.breaks.length > 0 && (
                                                                <ul>
                                                                    {timeSlot.breaks
                                                                    .slice()
                                                                    .sort((a, b) => a.start_at.localeCompare(b.start_at))
                                                                    .map((breakItem, breakIndex) => {
                                                                        const isHidden = !(breakItem?.is_visible ?? true);
                                                                        return (
                                                                            <li key={breakIndex} className="text-xs flex items-center gap-1">
                                                                                <span>Pausa</span>
                                                                                {isHidden && (
                                                                                    <EyeSlashIcon className="h-3 w-3 text-red-500" strokeWidth={2} />
                                                                                )}
                                                                                <span className={isHidden ? 'text-gray-400' : 'text-gray-600'}>
                                                                                    {breakItem.start_at} - {breakItem.end_at}
                                                                                </span>
                                                                            </li>
                                                                        );
                                                                    })}
                                                                </ul>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))
                                        ) : (
                                            <div className="text-sm text-gray-600">Nessun orario previsto</div>
                                        )}
                                    </div>

                                    <div className='col-span-1 items-center font-semibold text-sm text-gray-600 uppercase pt-1'>
                                        Giustificativo *
                                    </div>
                                    <div className='col-span-1 items-center border border-gray-200 rounded-lg shadow-md'>
                                        {selectedJustification && selectedJustification.time_slots && selectedJustification.time_slots.length > 0 ? (
                                            <ComboboxAutocomplete
                                                options={giustificativi.map((giustificativo) => ({
                                                    id: giustificativo.id,
                                                    name: giustificativo.justification.description,
                                                    value: giustificativo.id,
                                                    has_hours: giustificativo?.justification?.has_hours
                                                }))}
                                                bgActiveColor="bg-indigo-100"
                                                textActiveColor="text-gray-900"
                                                placeholder='Seleziona il giustificativo...'
                                                onChange={(selectedOption) => {
                                                    setGiustificativoSelected(selectedOption ?? null);
                                                    handleGiustificativoChange(selectedOption);
                                                }}
                                                value={giustificativoSelected}
                                                displayValue={(giustificativoSelected) => {
                                                    const selectedOption = giustificativi.find(
                                                        (giustificativo) => giustificativo.id === giustificativoSelected?.id
                                                    );
                                                    return selectedOption ? selectedOption.justification.description : '';
                                                }}
                                                positionOptions='absolute'
                                                required
                                            />
                                        ) : (
                                            <ComboboxAutocomplete
                                                options={giustificativi
                                                    .filter(giustificativo => giustificativo.justification.strategy === 'increase' || giustificativo.justification.strategy === null)
                                                    .map((giustificativo) => ({
                                                        id: giustificativo.id,
                                                        name: giustificativo.justification.description,
                                                        value: giustificativo.id,
                                                        has_hours: giustificativo?.justification?.has_hours
                                                    }))
                                                }
                                                bgActiveColor="bg-indigo-100"
                                                textActiveColor="text-gray-900"
                                                placeholder='Seleziona il giustificativo...'
                                                onChange={(selectedOption) => {
                                                    setGiustificativoSelected(selectedOption ?? null);
                                                    handleGiustificativoChange(selectedOption);
                                                }}
                                                value={giustificativoSelected}
                                                displayValue={(giustificativoSelected) => {
                                                    const selectedOption = giustificativi.find(
                                                        (giustificativo) => giustificativo.id === giustificativoSelected?.id
                                                    );
                                                    return selectedOption ? selectedOption.justification.description : '';
                                                }}
                                                positionOptions='absolute'
                                            />
                                        )}
                                    </div>
                                    
                                    {/* Data inizio */}
                                    <div className="col-span-1 font-semibold text-sm text-gray-600 uppercase pt-1">
                                        Dal giorno *
                                    </div>
                                    <div className="col-span-1 text-sm w-full">
                                        <input
                                            type="date"
                                            name="startDay"
                                            value={startDay}
                                            onChange={(e) => {
                                                const newStartDay = e.target.value;
                                                setStartDay(newStartDay);

                                                if (endDay && newStartDay > endDay) {
                                                    setEndDay(newStartDay);
                                                }

                                                setTimeError('');
                                            }}
                                            required
                                            className="mt-1 p-1 px-3 border border-gray-200 rounded-md
                                                    focus:ring-indigo-500 focus:border-indigo-500
                                                    block w-full shadow-md sm:text-sm
                                                    text-gray-700 bg-white cursor-pointer"
                                        />
                                    </div>

                                    {/* Data fine */}
                                    <div className="col-span-1 font-semibold text-sm text-gray-600 uppercase pt-1">
                                        Al giorno *
                                    </div>
                                    <div className="col-span-1 text-sm w-full">
                                        <input
                                            type="date"
                                            name="endDay"
                                            value={endDay}
                                            min={startDay || undefined}
                                            onChange={(e) => {
                                                setEndDay(e.target.value);
                                                setTimeError('');
                                            }}
                                            required
                                            className="mt-1 p-1 px-3 border border-gray-200 rounded-md
                                                    focus:ring-indigo-500 focus:border-indigo-500
                                                    block w-full shadow-md sm:text-sm
                                                    text-gray-700 bg-white cursor-pointer"
                                        />
                                    </div>
                        
                                    {giustificativoSelected && giustificativoSelected?.has_hours && (
                                        <>
                                            <div className='col-span-1 items-center font-semibold text-sm text-gray-600 uppercase pt-1'>
                                                Dalle ore *
                                            </div>
                                            <div className="col-span-1 text-sm items-center" style={{ position: 'relative' }}>
                                                <input 
                                                    type="text"
                                                    placeholder='hh:mm' 
                                                    value={startTime} 
                                                    onInput={handleStartTimeChange}
                                                    onBlur={() => handleWorkTimeBlur('start')}
                                                    className="mt-1 p-1 pl-4 border-gray-200 rounded-md focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-md sm:text-sm required" 
                                                    style={{ paddingRight: '2.5rem' }}
                                                    required
                                                />
                                                <span style={{ position: 'absolute', top: '50%', right: '8px', transform: 'translateY(-50%)' }}>
                                                <ClockIcon className='w-4 h-4' />
                                                </span>
                                            </div>      
                                            <div className='col-span-1 items-center font-semibold text-sm text-gray-600 uppercase pt-1'>
                                                Alle ore *
                                            </div>
                                            <div className='col-span-1 text-sm items-center' style={{ position: 'relative' }}>
                                                <input 
                                                    type="text"
                                                    placeholder='hh:mm' 
                                                    value={endTime} 
                                                    onInput={handleEndTimeChange} 
                                                    onBlur={() => handleWorkTimeBlur('end')}
                                                    className="t-1 p-1 pl-4 border-gray-200 rounded-md focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-md sm:text-sm required" 
                                                    style={{ paddingRight: '2.5rem' }}
                                                    required
                                                />
                                                <span style={{ position: 'absolute', top: '50%', right: '8px', transform: 'translateY(-50%)' }}>
                                                    <ClockIcon className='w-4 h-4' />
                                                </span>
                                            </div>
                                        </>
                                    )}

                                    <div className='col-span-1 items-center font-semibold text-sm text-gray-600 uppercase pt-1'>
                                        Note
                                    </div>
                                    <textarea 
                                        className='col-span-1 h-20 text-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-200 shadow-md rounded-md'
                                        value={note}
                                        onChange={(e) => setNote(e.target.value)}
                                    />
                                    <div className='col-span-1 items-center font-semibold text-sm text-gray-600 uppercase pt-1'>
                                        Associa Unità
                                    </div>
                                    <div className='col-span-1 items-center border border-gray-200 rounded-lg shadow-md'>
                                        <ComboboxAutocomplete
                                            options={units}
                                            bgActiveColor="bg-indigo-100"
                                            textActiveColor="text-gray-900"
                                            placeholder="Seleziona l'Unità Organizzativa"
                                            onChange={handleSelectUnit}
                                            value={tempSelectedUnit}
                                            positionOptions='relative'
                                        />
                                    </div>
                                </div>
                            </form>

                            {timeError && <div className='justify-center flex text-xs text-red-500 pt-2'>Compila tutti i campi obbligatori</div> }

                            <div className="p-4 flex justify-center">
                                <button
                                    type="button"
                                    className="hover:bg-indigo-100 text-xs flex justify-center focus:ring-indigo-500 focus:border-indigo-500 items-center border border-gray-300 shadow-md rounded-md w-full text-gray-500 font-bold btn-xs p-2 mr-4"
                                    onClick={handleSubmit}
                                    ref={cancelButtonRef}
                                >   
                                    <CheckIcon className="h-4 w-4 mr-1 text-indigo-800" />
                                    SALVA
                                </button>
                                <button
                                    type="button"
                                    className="hover:bg-gray-100 text-xs flex justify-center focus:ring-indigo-500 focus:border-indigo-500 items-center border border-gray-300 shadow-md rounded-md w-full text-gray-500 font-bold btn-xs p-2"
                                    onClick={closeModalAddGiustificativi}
                                >
                                    ANNULLA
                                </button>
                            </div>
                        </div>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition.Root>
    );
};

export default AddGiustificativoModal;
